<div *ngIf="isShowMoreHoursLink()" class="card-container">
  <p class="margintop--10 holiday-hours">
    <a id="toggle-text" class="toggle-link margin-0" (click)="showMoreHours()">View more hours</a>
  </p>
</div>
<dhcl-modal [show]="showModal" (closeClicked)="showModal = false;" [closeOnOverlay]="true">
  <div class="modal-container">
    <div *ngIf="labHourSets.length > 0">
      <fal-hours-card class="fal-hours-card" [headerTitle]="'Lab Hours'" [hours]="labHourSets"> </fal-hours-card>
    </div>
    <hr *ngIf="labHourSets && labHourSets.length > 0" class="line" />
    <h2 *ngIf="moreHours && moreHours.length > 0 && this.moreHours[0] !== ''">More Hours</h2>
    <div *ngFor="let moreHourDetails of moreHours" [innerHTML]="decodeHtml(moreHourDetails)"></div>
    <hr *ngIf="moreHours && moreHours.length > 0 && this.moreHours[0] !== ''" class="line" />
    <div *ngFor="let holidayHourDetails of holidayHours" [innerHTML]="decodeHtml(holidayHourDetails)"></div>
    <hr *ngIf="holidayHours && holidayHours.length > 0" class="line" />
    <div class="button-container">
      <button tabindex="0" (click)="hideMoreHours()" class="dhcl-button dhcl-button-primary dhcl-button-small">CLOSE MORE HOURS</button>
    </div>
  </div>
</dhcl-modal>
